import {
  MutationStatus,
  UseMutateAsyncFunction,
  useMutation
} from 'react-query';

import { getAPIErrorMessage } from '@nw/shared/utils';

import {
  UpdateUserApplicationRequestObjectType,
  UpdateUserApplicationResponseType
} from '../../../services/NwApplicationServices/APIService/types';

import { useNwApplicationService } from '../useNwApplicationService';

interface UseUpdateUserApplicationInterface {
  updateUserApplicationApi: UseMutateAsyncFunction<
    UpdateUserApplicationResponseType,
    Error,
    UpdateUserApplicationRequestObjectType
  >;
  error: string | null;
  status: MutationStatus;
}

const useUpdateUserApplicationApi = (): UseUpdateUserApplicationInterface => {
  const { nwApplicationService } = useNwApplicationService();

  const updateUserApplication = (
    requestObject: UpdateUserApplicationRequestObjectType
  ) => {
    return nwApplicationService.updateUserApplication(requestObject);
  };

  const { mutateAsync, error, status } = useMutation(updateUserApplication, {
    mutationKey: ['updateUserApplicationApi']
  });

  const updateUserApplicationApi = mutateAsync;

  return {
    updateUserApplicationApi,
    error: error ? getAPIErrorMessage(error) : null,
    status
  };
};

export { useUpdateUserApplicationApi };
